import { IconButton, Heading, Text, Button, HStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import type { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { useRedeemDetailsContext } from '../../contexts/redeem-details';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const { handleCancelRedeemOffers } = useRedeemDetailsContext();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const iconSize = isMobile ? 'xxs' : 'xs';
  const iconColor = isMobile ? 'brand.primary.principal' : 'brand.tertiary.principal';
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  return (
    <HStack w="full" alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          onPress={() => navigate('BatchTicketRequests')}
          variant="link"
          {...(isMobile && { p: 0, backgroundColor: 'transparent' })}
          {...(!isMobile && { shadow: 3 })}
          iconColor={Color[iconColor]}
          iconSize={iconSize}
        />
        {isMobile ? (
          <Text variant="semibold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Detalhes da ordem
          </Text>
        ) : (
          <Heading testId="qa" size="h2">
            Detalhes da ordem
          </Heading>
        )}
      </HStack>
      {isMobile && (
        <Button
          variant="textLink"
          onPress={handleCancelRedeemOffers}
          _text={{
            color: 'feedback.error.default',
            fontWeight: Typography['fontweight.semibold'],
          }}>
          Cancelar
        </Button>
      )}
    </HStack>
  );
};
